<template>
  <div class="news_list" v-if="list.length > 0">
    <div
      class="news_item"
      :class="item.is_ad == 1 ? 'ad' : ''"
      @click="navigator(item.id, item.is_ad)"
      v-for="item in list"
      :key="item.id"
    >
      <div
        class="image"
        :style="{ backgroundImage: 'url(' + item.photopath + ')' }"
      >
        <img :src="item.photopath" />
      </div>
      <div class="right">
        <!--v-if="item.is_ad == 0"-->
        <div class="tit">
          {{ item.title }}
        </div>
        <div class="desc hidden-xs">
          {{ item.subtitle }}
        </div>
        <div class="info">
          <span>
            <img src="../../static/news/icon_click.png" />{{ item.view_num }}
          </span>
          <span>{{ item.createdAt }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="news_list" v-else>
    <div class="no_data">
      <div class="no_icon"></div>
      <div class="no_text">暂无数据</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["list"],
  filters: {
    formatDate(date) {
      const nDate = new Date(date);
      const year = nDate.getFullYear();
      const month = nDate
        .getMonth()
        .toString()
        .padStart(2, 0);
      const day = nDate
        .getDay()
        .toString()
        .padStart(2, 0);
      return year + "-" + month + "-" + day;
    }
  },
  methods: {
    navigator(id, is_ad) {
      this.$emit("itemClick", id, is_ad);
    }
  }
};
</script>

<style lang="less" scoped>
.news_list {
  flex-direction: column;
  margin-bottom: 0.3rem;

  .news_item {
    flex-direction: row;
    padding: 0.29rem 0rem;
    border-top: 0.01rem solid rgba(196, 196, 204, 0.2);
    width: 100%;
    display: flex;
    cursor: pointer;

    .image {
      width: 4.1rem;
      height: 2.3rem;
      background-size: cover !important;
      background-repeat: no-repeat !important;
      background-position: center center !important;
      border-radius: 0rem;
      img {
        width: 100%;
        opacity: 0;
      }
      @media (max-width: 991px) {
        width: 3rem;
        height: 1.68rem;
      }
    }

    .right {
      width: ~"calc(100% - 4.5rem)";
      margin-left: 0.4rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      @media (max-width: 991px) {
        width: ~"calc(100% - 3rem)";
      }

      .tit {
        margin-top: 0.18rem;
        font-size: 0.2rem;
        margin-bottom: 0.25rem;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-box-pack: center;
        -webkit-box-align: center;
        -webkit-line-clamp: 2;
        overflow: hidden;
        line-height: 0.33rem;
        //height: 0.66rem;
        text-align: left;
        @media (max-width: 991px) {
          font-size: 0.26rem;
        }
      }

      .desc {
        font-size: 0.14rem;
        margin-bottom: 0.25rem;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        line-height: 0.2rem;
        height: 0.4rem;
        text-align: left;
      }

      .info {
        font-size: 0.16rem;
        color: #8d8e99;
        text-align: left;
        display: flex;
        span:nth-child(1) {
          margin-left: 0rem;
          align-items: center;
          margin-right: 0.6rem;
          display: flex;

          img {
            width: 0.2rem;
            height: 0.14rem;
            margin-right: 0.04rem;
            @media (max-width: 991px) {
              width: 0.28rem;
              height: 0.19rem;
            }
          }
        }

        text:nth-child(1) {
        }
        @media (max-width: 991px) {
          font-size: 0.24rem;
        }
      }
    }
    &:first-child {
      border-top: 0.01rem solid rgba(196, 196, 204, 0);
    }
  }
  .ad {
    border-top: 0.01rem solid rgba(196, 196, 204, 0);
    .image {
      width: 6.86rem;
      height: 1.72rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .ad + .news_item {
    border-top: 0.01rem solid rgba(196, 196, 204, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/news-item.vue